export enum AgreementCode {
  SOP = 196,
  PENSJONSKUNDE_CORPORATE = 200,
  AVVENTENDE_PENSJONSKUNDE_CORPORATE = 201,
  AKA_CORPORATE_ARKITEKTENES = 280,
  AKA_CORPORATE_DEN_NORSKE_LEGEFORENING = 281,
  AKA_CORPORATE_DEN_NORSKE_TANNLEGEFORENING = 282,
  AKA_CORPORATE_DEN_NORSKE_VETRINERFORENING = 283,
  /**
   * @deprecated agreement code no longer in use
   */
  AKA_CORPORATE_ECONA = 284,
  AKA_CORPORATE_NATURVITERNE = 287,
  AKA_CORPORATE_NORSK_LEKTORLAG = 288,
  AKA_CORPORATE_NORSK_PSYKOLOGIFORENING = 289,
  AKA_CORPORATE_SAMFUNNSVITERNE = 290,
  AKA_CORPORATE_SAMFUNNSOKONOMENE = 291,
  PREPAY_CORPORATE = 395,
  FLEET = 398,
  ORDINARY_CORPORATE = 399,
  REMA = 400,
  HUSEIERNE = 410,
  HUSEIERNE_PREPAY = 411,
  HUSEIERNE_CORPORATE = 412,
  COOP = 420,
  COOP_PREPAY = 421,
  DANSKE_BANK = 430,
  AURORA_MIGRATION = 432,
  AURORA_MIGRATION_WITHOUT_ADMIN = 433,
  DANSKE_BANK_MIGRATION = 434,
  DANSKE_BANK_MIGRATION_WITHOUT_ADMIN = 435,
  STOREBRAND_EMPLOYEES = 500,
  STOREBRAND_RETIREES = 501,
  GROUP_INSURANCE = 530, // Special agreement
  SKADE_VIP = 550, // Samarbeidspartner
  NORSKELBILFORENING = 555,
  AKA_ARKITEKTENES_FAGFORBUND = 580,
  AKA_DEN_NORSKE_LEGEFORENING = 581,
  AKA_DEN_NORSKE_TANNLEGEFORENING = 582,
  AKA_DEN_NORSKE_VETERINAERFORENING = 583,
  AKA_ECONA = 584,
  AKA_NATURVITERNE = 587,
  AKA_NORSK_LEKTORLAG = 588,
  AKA_NORSK_PSYKOLOGIFORENING = 589,
  AKA_SAMFUNNSVITERNE = 590,
  AKA_SAMFUNNSOKONOMENE = 591,
  AKA_SPECIAL_AGREEMENT = 595,
  SPECIAL_AGREEMENT = 599,
  FFA_PROGRAM = 601, // Storebrand fordel
  FRAM = 603,
  PENSJONSKASSEFORENINGEN = 604,
  EMPLOYED_SMB_CORPORATE = 605,
  PARTNER_SUPER = 790,
  PARENT_COMPANY_CUSTOMER = 800, // Storebrand felleskunde (Samlerabatt)
  COLLECTIVE = 900,
  PARTNER_STANDARD = 910,
  SPECIAL_PAYER = 950,
  PREPAY = 995,
  EXTERNAL_PARTNER_FINN = 997,
  ORDINARY = 999,
}

export const AkaAgreements = [
  AgreementCode.AKA_ARKITEKTENES_FAGFORBUND,
  AgreementCode.AKA_DEN_NORSKE_LEGEFORENING,
  AgreementCode.AKA_DEN_NORSKE_TANNLEGEFORENING,
  AgreementCode.AKA_DEN_NORSKE_VETERINAERFORENING,
  AgreementCode.AKA_ECONA,
  AgreementCode.AKA_NATURVITERNE,
  AgreementCode.AKA_NORSK_LEKTORLAG,
  AgreementCode.AKA_NORSK_PSYKOLOGIFORENING,
  AgreementCode.AKA_SAMFUNNSVITERNE,
  AgreementCode.AKA_SAMFUNNSOKONOMENE,
];

export const CoopAgreements = [AgreementCode.COOP, AgreementCode.COOP_PREPAY];

export const DanskeBankMigratedAgreements = [
  AgreementCode.AURORA_MIGRATION,
  AgreementCode.AURORA_MIGRATION_WITHOUT_ADMIN,
  AgreementCode.DANSKE_BANK_MIGRATION,
  AgreementCode.DANSKE_BANK_MIGRATION_WITHOUT_ADMIN,
];

export const DanskeBankNewAgreements = [AgreementCode.DANSKE_BANK];

export const HuseierneAgreements = [
  AgreementCode.HUSEIERNE,
  AgreementCode.HUSEIERNE_PREPAY,
  AgreementCode.HUSEIERNE_CORPORATE,
];

export const CollectiveAgreements = [
  AgreementCode.PARENT_COMPANY_CUSTOMER,
  AgreementCode.COLLECTIVE,
];

export const UnlimitedYearlyKmNeedAgreements = [
  AgreementCode.STOREBRAND_EMPLOYEES,
  AgreementCode.STOREBRAND_RETIREES,
  AgreementCode.EXTERNAL_PARTNER_FINN,
];
